import React, { Component } from 'react'
import cx from 'classnames'
import { withUiContext } from '../../UiContext'

class MapProjectPoint extends Component{
	playOverSound = () => {
		const {ui} = this.props
		ui.playOverSound()
	}

	playClickSound = () => {
		const {ui} = this.props
		ui.playClickSound()
	}

	handleMouseEnter = () => {
		this.playOverSound()
		if (this.props.onMouseEnter) this.props.onMouseEnter()
	}

	handleClick = () => {
		this.playClickSound()
		const { onClick } = this.props
		if (onClick) onClick()
	}

	render(){
		const { className, style, label, point } = this.props

		const width = typeof point !== "undefined" && typeof point.width !== "undefined" ? point.width : 75;
		const height = typeof point !== "undefined" && typeof point.height !== "undefined" ? point.height : 75;

		return(
			<div className={cx("hud-map__point", className)} style={style}>
				<div className="hud-map__pointer" onClick={this.handleClick} onMouseEnter={this.handleMouseEnter} style={{
					width: width,
					height: height,
				}} />
				<div className="hud-map__label" onClick={this.handleClick} onMouseEnter={this.handleMouseEnter}>{label}</div>
			</div>
		)
	}
}

export default withUiContext(MapProjectPoint)
